import React from "react"
import "style.css"
import "tailwindcss/dist/base.css"
import AnimationRevealPage from "helpers/AnimationRevealPage"
import Services from "components/features/ThreeColSimple"
import Hero from "components/hero/BackgroundAsImage"
import TextSection from "components/features/TextSection"
import TextSection2 from "components/features/TextSection2"
import Stats from "components/features/ThreeColCenteredStatsPrimaryBackground"
import Contact from "components/forms/TwoColContactUsWithIllustrationFullForm"
import GetStarted from "components/cta/GetStarted"
import Footer from "components/footers/FiveColumnWithBackground"
import Testimonials from "components/testimonials/TwoColumnWithImage"
import Feature1 from "components/features/TwoColWithButton"
import gif1 from "../images/gif1.gif"
import gif2 from "../images/gif2.gif"
import gif3 from "../images/gif3.gif"

import Media from "components/cards/PortfolioTwoCardsWithImage"
import {useSelector} from "react-redux";
import {LangProvider} from "../lang";
import translate from "../lang/translate";


function HomePage() {
    const locale = useSelector(state => state.locale);
  return (
      <LangProvider locale={locale}>
          <AnimationRevealPage>
              <Hero />
              <TextSection />
              <Stats />
              <Services />
              <TextSection2 />
              <Feature1
                  imageSrc={gif1}
                  heading={null}
                  subheading={null}
                  primaryButtonText={translate('home_page.watch_how_video')}
                  primaryButtonUrl="https://www.youtube.com/channel/UC0Ltsu_2FrfUneg0jk8ol2Q"
                  description={translate('home_page.upload_cv_description')}
                  showButton={true}
              />
              <Feature1
                  imageSrc={gif2}
                  heading={null}
                  subheading={null}
                  primaryButtonText={translate('home_page.optimize_cv')}
                  primaryButtonUrl="https://www.youtube.com/channel/UC0Ltsu_2FrfUneg0jk8ol2Q"
                  textOnLeft={false}
                  description={translate('home_page.adapt_cv_description')}
                  showButton={true}
              />
              <Feature1
                  imageSrc={gif3}
                  heading={null}
                  subheading={null}
                  primaryButtonText={translate('home_page.spice_up_profile')}
                  primaryButtonUrl="https://www.youtube.com/channel/UC0Ltsu_2FrfUneg0jk8ol2Q"
                  description={translate('home_page.select_profile_description')}
                  showButton={true}
              />
              <GetStarted text={translate('home_page.take_your_chance')} secondaryLinkText={null}/>
              {/* <Testimonials /> */}
              <Media
                  subheading={false}
                  headingHtmlComponent={translate('home_page.media.description1')} description={translate('home_page.media.description2')} linkText={translate('home_page.media.read_more')}
                  
                  />
              <Contact />
              <Footer />
          </AnimationRevealPage>
      </LangProvider>
  )
}
export default HomePage
